export default "__VITE_ASSET__BZdLkh5L__"